import { Check } from 'lucide-react';
import { ONBOARDING_GENRES } from '../../constants/emotions';

interface GenreStepProps {
  selectedGenres: number[];
  onToggleGenre: (genreId: number) => void;
  maxSelections?: number;
}

export function GenreStep({ selectedGenres, onToggleGenre, maxSelections = 3 }: GenreStepProps) {
  const canSelectMore = selectedGenres.length < maxSelections;

  return (
    <div className="space-y-4">
      <div className="text-center">
        <h3 className="text-lg font-semibold text-white mb-1">
          What genres do you love?
        </h3>
        <p className="text-sm text-slate-400">
          Pick up to {maxSelections} favorite genres
        </p>
      </div>

      {/* Selected count */}
      <div className="flex justify-center">
        <span className="text-sm text-slate-400">
          {selectedGenres.length} / {maxSelections} selected
        </span>
      </div>

      {/* Genre grid */}
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {ONBOARDING_GENRES.map((genre) => {
          const isSelected = selectedGenres.includes(genre.id);
          const isDisabled = !isSelected && !canSelectMore;

          return (
            <button
              key={genre.id}
              type="button"
              onClick={() => onToggleGenre(genre.id)}
              disabled={isDisabled}
              className={`relative flex flex-col items-center justify-center p-3 rounded-xl border-2 transition-all ${
                isSelected
                  ? 'border-cyan-500 bg-cyan-500/10'
                  : isDisabled
                  ? 'ring-white/[0.06] bg-[#0F1419]/50 opacity-50 cursor-not-allowed'
                  : 'ring-white/[0.08] bg-[#1A1F26]/50 hover:ring-white/[0.12]'
              }`}
            >
              {/* Selection indicator */}
              {isSelected && (
                <div className="absolute top-1 right-1 w-4 h-4 bg-cyan-500 rounded-full flex items-center justify-center">
                  <Check size={10} className="text-white" />
                </div>
              )}

              {/* Icon */}
              <span className="text-2xl mb-1">{genre.icon}</span>

              {/* Name */}
              <span className="text-xs font-medium text-white text-center">
                {genre.name}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
